/**
 * AppRoot - Main routing component for Flux PhD
 *
 * PhD is project-independent — no project gate required.
 * Routes directly to FluxPhdApp for all paths.
 */

import React from 'react';
import { Routes, Route } from 'react-router-dom';
import FluxPhdApp from './FluxPhdApp';

export default function AppRoot() {
    return (
        <Routes>
            <Route path="/*" element={<FluxPhdApp />} />
        </Routes>
    );
}
